<template>
  <a @click="onClickHandle" class="article-index">
    <div class="panel panel-default" v-if="article.post_id">
      <div v-if="article.articleTypeSlug === 'columns_cat' && article.full_thumbnail">
        <img class="article-thumbnail" :src="article.full_thumbnail" />
      </div>
      <div class="panel-body">
        <div class="article-top" :style="{ color: `${subTitleColor}` }">
          <span>{{ article.post_date }}&nbsp;</span>
          <span>{{ articleTypeText }}</span>
          <span class="top-right-container">
            <span :key="`${article.post_id}-${icsTypeArr}`">
              <ics-tag :ics_type="icsTypeArr"></ics-tag>
            </span>
          </span>
        </div>

        <div class="article-title">
          {{ article.title }}
        </div>
        <div class="article-excerpt" v-if="articlePage">
          {{ article.excerpt }}
        </div>
        <div v-if="article.articleTypeSlug !== 'daily_news' && articlePage" class="article-author">
          {{ article.author }}<br />
          {{ article.author_title }}
        </div>
      </div>
    </div>
  </a>
</template>

<script>
import IcsTag from '@/components/Article/IcsTag';

export default {
  props: {
    article: {
      required: true,
    },
    icstype: {
      type: String,
    },
    articleType: {
      type: String,
    },
    articlePage: {
      type: Boolean,
      default: true,
    },
    subTitleColor: {
      type: String,
      default: '#000000',
    },
  },
  components: {
    IcsTag,
  },
  computed: {
    icsTypeArr() {
      if (this.article.ics_type.length > 1 || this.article.ics_type.length === 0) {
        return 'ics';
      }
      return `${this.article.ics_type[0]}`;
    },
    articleTypeText() {
      let title = '';
      if (this.article.articleTypeSlug === 'ici_guide') title = this.$t('main.DRAWER_ICS_GUIDE');
      else if (this.article.articleTypeSlug === 'columns_cat') {
        title = this.$t(`article.${this.article.articleCategoriesSlug}`);
      } else {
        title = this.$t(`article.${this.article.articleTypeSlug}`);
      }
      return title;
    },
  },
  methods: {
    onClickHandle() {
      if (this.articlePage) {
        this.$emit('clicked', this.article);
      } else {
        const url = `/ics/property/article/detail/${this.article.post_id}`;
        window.open(url);
      }
    },
  },
};
</script>

<style scoped>
.article-index {
  color: inherit;
}

.article-index .panel.panel-default {
  margin-bottom: 0px;
  border-radius: 0;
  border: 0;
  background-color: unset;
}

.article-index .panel.panel-default .panel-body {
  padding: 5px 15px;
}

.article-top {
  display: flex;
}

.article-thumbnail {
  width: 100%;
  display: block;
}

.top-right-container {
  margin-left: auto;
  display: flex;
}

.article-title {
  font-size: 1.375rem;
  padding-bottom: 1vh;
}

.article-excerpt {
  font-size: 1rem;
  color: #b6b6b6;
}

.article-author {
  text-align: right;
  margin-top: 5px;
}
</style>
